import React from "react";
import AppIcons from "../utils/appIcons";
import { Box, Typography } from "@mui/material";
import Strings from "../utils/stringUtil";
import FillButton from "../components/ui/fillButton";
import theme from "../utils/themeUtil";
import { Link } from "react-router-dom";
import Routes from "../utils/routesUtil";
import styles from "../assets/styles/main.module.css";
import { isMobile } from "../utils/responsiveUtil";

function NotFound() {
  return (
    <React.Fragment>
      <Box className={styles.container}>
        <Box mt={5} display={'flex'} flexDirection={'column'} alignItems={'center'}>
          <img
            src={AppIcons.imgNotFound}
            alt="Not Found"
            width={isMobile ? "100%" : "450"}
          />

          <Typography variant="subtitle2" color={theme.palette.lightBlack.main}>
            {Strings.notFoundMessage}
          </Typography>
          <Box mt={3}>
            <Link to={Routes.HOME}>
              <FillButton
                backgroundColor={theme.palette.primary.main}
                textColor={theme.palette.white.main}
                text={Strings.goToHomePage}
              />
            </Link>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default NotFound;
